import { HTMLAttributes } from 'react';

/**
 * Utility that creates handler functions that call the `onMetaClick` handler when either:
 * - the meta or ctrl key is pressed during a click
 * - he element is clicked with the middle mouse button
 * Use the `onClick` handler to add an additional handler that gets called on regular clicks.
 * @returns onClick and onAuxClick handlers
 */
export function addMetaClickHandlers<T extends HTMLElement>({
  onMetaClick,
  onClick,
}: {
  /**
   * handler that gets called when the element is clicked with meta or ctrl key or is clicked with the middle mouse button.
   */
  onMetaClick: (event: React.MouseEvent<T>) => void;
  /**
   * Optional additional onClick handler that gets merged with the onMetaClick handler and gets called when the element is clicked
   * regularly
   */
  onClick?: (event: React.MouseEvent<T>) => void;
}): Pick<HTMLAttributes<T>, 'onClick' | 'onAuxClick'> {
  return {
    onClick(event) {
      if (event.metaKey || event.ctrlKey) {
        onMetaClick(event);
        return;
      }
      onClick?.(event);
    },
    onAuxClick(event) {
      event.preventDefault();
      // middle click
      if (event.button === 1) {
        onMetaClick(event);
      }
    },
  };
}
